import { render, staticRenderFns } from "./naj-settings-box.vue?vue&type=template&id=2c4beb02&scoped=true&"
import script from "./naj-settings-box.vue?vue&type=script&lang=js&"
export * from "./naj-settings-box.vue?vue&type=script&lang=js&"
import style0 from "./naj-settings-box.vue?vue&type=style&index=0&id=2c4beb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4beb02",
  null
  
)

export default component.exports